// local
// export const baseUrl = 'http://localhost:3000/api'
// export const aiApisUrl = 'http://localhost:6898'
// export const mtbirdUrl = 'http://localhost:8888'

// production
export const baseUrl = "/api";
export const aiApisUrl = "https://api.ai.staringos.com";
export const mtbirdUrl = "https://mtbird.staringos.com";

export const imageCDNUrl = "https://mtbird-cdn.staringos.com";

// for staringai
// export const appId = 'wxc898274cce90a6de'
// export const loginType = 'independence'
// export const mtbirdAppId = '53f628d1-8a21-40fe-84ba-352beb581ac0'
// export const isVectorSearch = false
// export const vectorCollectionName = 'menu2'
// export const needRobotVoice = false

// for laoban
export const appId = "wx0338d06f0e8d0b6d";
export const loginType = "";
export const mtbirdAppId = "53f628d1-8a21-40fe-84ba-352beb581ac0";
export const isVectorSearch = true;
export const vectorCollectionName = "menu2";
export const needRobotVoice = true;
export const defaultAssistantId = "clfwe1qtz00024zruzu2zy0bx";
